import React from 'react';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import TextField from 'material-ui/TextField';
import { inject, observer } from 'mobx-react';

@inject('createTutorialStore')
@observer
export default class CpdOptions extends React.Component {

  state = {
    cpd_status: 'applied',
    icgp_number: '',
    cpd_points: ''
  }

  componentDidMount() {
    setTimeout(this.setCPDOptions, 1000);
  }

  setCPDOptions = () => {
    const { tutorial } = this.props.createTutorialStore;

    if(tutorial.id) {
      this.setState({
        cpd_status: tutorial.cpd_status ? 'granted' : 'applied',
        icgp_number: tutorial.icgp_number || '',
        cpd_points: tutorial.cpd_points || ''
      });
    }
  }

  handleChangeStatus = (e, key, payload) => {
    if (payload == 'applied') {
      this.setState({
        ...this.sate,
        cpd_status: payload,
        icgp_number: '',
        cpd_points: ''
      });
      this.props.createTutorialStore.handleChange({ cpd_status: false, icgp_number: '', cpd_points: '' });
    } else {
      this.setState({
        ...this.sate,
        cpd_status: payload
      })
      this.props.createTutorialStore.handleChange({ cpd_status: payload });
    }
  };

  handleChange = e => {
    this.setState({
      ...this.state,
      [e.target.name]: e.target.value
    })
    this.props.createTutorialStore.handleChange({[e.target.name]: e.target.value});
  }

  render() {
    // let errors = this.props.createTutorialStore.errors;
    // if (!errors)
    //   errors = {};
    return (
      <div className="cpd-options-wrapper">
        <h3>CPD Options</h3>
        <div className="custom-row">
          <div className="input-wrap">
            <SelectField
              //errorText={this.state.errorText}
              selectedMenuItemStyle={{ color: 'white', backgroundColor: '#34b6f1' }}
              value={this.state.cpd_status}
              onChange={this.handleChangeStatus}
              hintText='Select CPD status'>
              <MenuItem value='applied' key='1' primaryText='Applied for' />
              <MenuItem value='granted' key='2' primaryText='Granted' />
            </SelectField>
          </div>
          {this.state.cpd_status == 'granted' && <div className="input-wrap">
            <TextField
              onChange={this.handleChange}
              className='icgp_number'
              name="icgp_number"
              //errorText={errors.title}
              value={this.state.icgp_number || ''}
              floatingLabelText="ICGP reference number"
              type="text"
            />
          </div>}
          {this.state.cpd_status == 'granted' && <div className="input-wrap">
            <TextField
              onChange={this.handleChange}
              className='cpd_points'
              name="cpd_points"
              //errorText={errors.title}
              value={this.state.cpd_points || ''}
              floatingLabelText="External CPD points"
              type="text"
            />
          </div>}
        </div>
      </div>

    )
  }
}



// WEBPACK FOOTER //
// ./src/modules/blocks/tutorial_popup/CpdOptions.js